export default __webpack_public_path__ + "static/edih_fill-011f89e187706a9016177a6019df2cb2.jpg";